// DEPENDENCIES ---------------------------------------------------------------- //

import { Typography, useTheme } from '@mui/material';

import type { EligibilityView } from '@features/moveCreation/lib/programVehicleEligibility';

// COMPONENTS ---------------------------------------------------------------- //

/**
 * The eligibility verdict and its hint, as one line. The pinned coverage bar and
 * the summary at the end of the form both show it, so a dealer who sees "Not
 * eligible" in either place reads the same reason. The rule rows under it come
 * from @hopdrive/feature-program-claims, which the claims list shares.
 */
export const EligibilityStatusLine = ({ view }: { view: EligibilityView }) => {
  const theme = useTheme();
  const color = {
    waiting: theme?.palette?.text?.secondary,
    eligible: theme?.palette?.success?.main,
    ineligible: theme?.palette?.error?.main,
  }[view.status];
  return (
    <>
      <Typography sx={{ fontSize: `13px`, fontWeight: 600, color }}>{view.statusText}</Typography>
      {view.hint ? (
        <Typography data-testid='program-eligibility-hint' sx={{ fontSize: `12px`, color: theme?.palette?.text?.secondary }}>
          {view.hint}
        </Typography>
      ) : null}
    </>
  );
};
